import { Component, OnInit } from '@angular/core';
//import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ILogin } from 'src/app/_services/ApplicationServices/login';
import { LoginService } from 'src/app/_services/ApplicationServices/login.service';
import { GlobalService } from 'src/app/_services/CommonServices/global.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { ActivatedRoute } from '@angular/router';
import { AppInsightsService } from 'src/app/_services/ReportServices/app-insights.service';
import { FormBuilder, FormGroup } from '@angular/forms';
// import { Globals } from '../../_utlity/globals';
// import * as constants from "../../_utlity/constants";
// import { AuthService } from '../../_services/auth.service';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
  //constructor(private router:Router, private _global: Globals, private auth: AuthService) { }
  constructor(private router: Router, private loginService: LoginService, private appInsight: AppInsightsService,
    private msAuthService: MsalService, private global: GlobalService, private formBuilder: FormBuilder,
    private msalBroadcastService: MsalBroadcastService, private httpClient: HttpClient, private actRoute: ActivatedRoute) { }
  user = { email: '', password: '' };

  _loginMessage: string;
  returnUrl: string;
  EmployeeName: string;
  EmployeeSubGroup: string;
  OnBehalf: boolean = false;
  Designation: string;
  employeeDetail: any[] = [];
  errorMessage: string;
  SapId: string;
  public get loginMessage(): string {
    return this._loginMessage;
  }
  public set loginMessage(value: string) {
    this._loginMessage = value;
  }


  ngOnInit(): void {
    this.getUserInfo();
  }
  getUserInfo() {
    //console.log("Login Successful");
    this.loginMessage = "";
    //localStorage.setItem("SapId",null);
    sessionStorage.setItem('isLoggedIn', "true");
    //localStorage.setItem("SapId",(this.user.email));
    //sessionStorage.setItem("SapId",(this.user.email));
    this.loginService.isloginPage = true;
    localStorage.setItem('isLoggedInDelegated', "true");
    this.loginService.getAuthenticationInfo(this.user.email).subscribe(
      {
        next: empInfo => {
          // this.employeeDetail = empInfo.Data;
          // if (this.employeeDetail.length > 0) {
            this.employeeDetail = empInfo;
            if (this.employeeDetail[0]) {
            localStorage.setItem("IsShowHeaderDeatils", "true");
            this.EmployeeName = this.employeeDetail[0]?.EmpName;
            this.EmployeeSubGroup = this.employeeDetail[0]?.EMEmpSubgroup;
            this.Designation = this.employeeDetail[0]?.EMDesig;

            //store  SAPID with login ID use the API calling
            this.global.UserLoggedInSAPID = this.employeeDetail[0]?.EMEmpCode;
            this.loginService.pullEncryptValue(this.global.UserLoggedInSAPID).subscribe(data => {
              //localStorage.setItem("SapId", data.clearText);
              this.global.setSapId(data.clearText);
              //localStorage.setItem("UserLoggedInSAPID",this.employeeDetail[0].EMEmpCode);
              this.router.navigate(['approval']);
            });

            if (this.employeeDetail[0]?.ADVDelFlag == 1) {
              this.OnBehalf = true;
              //localStorage.setItem("Onbehalf", this.OnBehalf.toString());
              this.global.setOnBehalf(this.OnBehalf.toString());
              //console.log('header componenet true block value : '+this.OnBehalf);
            }
            else {
              this.OnBehalf = false;
              //.localStorage.setItem("Onbehalf", this.OnBehalf.toString());
              this.global.setOnBehalf(this.OnBehalf.toString());
              //console.log('header componenet false block value : '+this.OnBehalf);
            }
          }
          else {
            this.router.navigate(['Unauthorized']);
            sessionStorage.setItem("IsShowHeaderDeatils", "false");
          }
        },
        error: err => this.errorMessage = err
      }
    )
    //this.router.navigate(['Unauthorized']);
    //this.appInsight.setAuthenticatedUserId(this.user.email);
  }
}
